import React from 'react'
import Pt from 'prop-types'
import { Step as RealStep } from 'rc-steps'
import { Link } from 'react-router'

import Icon from 'internal-components/src/components/Icon'

export default function Step({
  completed,
  error = false,
  iconName,
  linkTo,
  title,
  ...props
}) {
  let status = 'wait'
  let icon = iconName
  if (completed) {
    status = 'finish'
    icon = 'check'
  }
  if (error) {
    status = 'error'
    icon = 'exclamation-triangle'
  }

  return (
    <RealStep
      {...props}
      icon={<Icon name={icon} fixedWidth />}
      status={status}
      title={linkTo ? <Link to={linkTo}>{title}</Link> : title}
    />
  )
}

Step.propTypes = {
  completed: Pt.bool.isRequired,
  error: Pt.bool,
  iconName: Pt.string.isRequired,
  linkTo: Pt.oneOfType([Pt.string, Pt.bool]),
  title: Pt.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ProgressSummary/Step.jsx